import { render } from "./ChatSlideUpDown.vue?vue&type=template&id=5886d93d&scoped=true"
import script from "./ChatSlideUpDown.vue?vue&type=script&lang=js"
export * from "./ChatSlideUpDown.vue?vue&type=script&lang=js"

import "./ChatSlideUpDown.vue?vue&type=style&index=0&id=5886d93d&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5886d93d"],['__file',"webpack-assets/vue/templates/chat/parts/ChatSlideUpDown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5886d93d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5886d93d', __exports__)) {
    api.reload('5886d93d', __exports__)
  }
  
  module.hot.accept("./ChatSlideUpDown.vue?vue&type=template&id=5886d93d&scoped=true", () => {
    api.rerender('5886d93d', render)
  })

}


export default __exports__